import { Component, signal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, AlertTriangle } from 'lucide-angular';

@Component({
  selector: 'app-sunset-banner',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './sunset-banner.component.html',
  styleUrl: './sunset-banner.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SunsetBannerComponent {
  AlertTriangle = AlertTriangle;

  isDismissed = signal<boolean>(!!sessionStorage.getItem('sunset-acknowledged'));

  dismissBanner() {
    this.isDismissed.set(true);
    sessionStorage.setItem('sunset-acknowledged', '1');
  }
}
